<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <app-table
          hide-upsert
          :config="config"
          @addRequest="addRequest"
          @viewRequests="viewRequests"
          @saved="newProtocol"
          @edit="editProtocol"/>

        <v-dialog
          v-model="openRequest"
          max-width="650px">

          <app-upsert
            v-if="openRequest"
            :config="requestConfig"
            :item="{ protocol_id: protocol.id, request_date }"
            :subtitle="protocol.name"
            modal
            @close="openRequest=false"
            @saved="requestSaved" />

        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.json'
import requestConfig from './request_config.js'
import moment from 'moment'

import { mapState } from 'vuex'

export default {
  data () {
    return {
      config,
      requestConfig,
      protocol: {},
      openRequest: false
    }
  },
  computed: {
    ...mapState(['user']),
    request_date () {
      return moment().format('YYYY-MM-DD')
    },
    getData () {
      if (this.user.role !== 'Site') {
        return null
      }
      return null
    }
  },
  methods: {
    newProtocol ({ data }) {
      this.$router.push(`/protocol/${data.id}`)
    },
    editProtocol(protocol) {
      this.$router.push(`/protocol/${protocol.id}`)
    },
    addRequest (protocol) {
      this.protocol = protocol
      this.openRequest = true
    },
    requestSaved (request) {
      this.$router.push(`/request/${request.assetId}`)
    },
    viewRequests (protocol) {
      this.$router.push(`/protocol/request/${protocol.id}`)
    }
  }
}
</script>
